import {PurposesService} from "../../../../../common/api/dictionaries";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class BackofficePurposesService extends PurposesService {
    constructor(http: HttpClient) {
        super(http);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/backoffice.purposes.service.ts